```vue
<template>
    <v-col cols="12">
        <v-form ref="addTallaColorForm">
            <base-card>
                <v-card-title>
                    Activar parametro ADD_TALLA_COLOR
                </v-card-title>

                <v-card-subtitle class="mt-2">
                    Activar parametro para concatenar talla-color-barcode a la descripcion.
                </v-card-subtitle>

                <v-card-text>
                    <!-- COMPAÑÍA + CONFIGURACIÓN -->
                    <v-row align="center">
                        <!-- COMPAÑÍA -->
                        <v-col cols="12" sm="4">
                            <v-select ref="company" v-model="data.IdCompania" :items="detailClients" item-text="text"
                                item-value="IdCompania" label="Compañía" prepend-inner-icon="mdi-sitemap"
                                :disabled="!isAdmin || loadingConfig" :error="companySelectorError"
                                :rules="[validateCompanyField]" :error-messages="helperSelectorText"
                                @change="handleSelectCompany">
                                <!-- Buscador únicamente para administradores -->
                                <template v-if="isAdmin" v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-text-field class="search-field" v-model="search"
                                                    placeholder="Buscar compañía" prepend-inner-icon="mdi-magnify"
                                                    hide-details />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-col>

                        <!-- ACTIVADOR DEL PARÁMETRO -->
                        <v-col v-if="companySelected" cols="12" sm="5">
                            <div class="d-flex align-center">
                                <v-switch v-model="data.enabled" :label="data.enabled
                                        ? 'Parámetro activado'
                                        : 'Parámetro desactivado'
                                    " color="success" inset :disabled="loadingConfig" hide-details />
                            </div>

                            <div class="caption grey--text mt-1">
                                {{
                                    data.enabled
                                        ? 'Se concatenará talla, color y código de barras a la descripción.'
                                        : 'No se aplicará esta concatenación.'
                                }}
                            </div>
                        </v-col>

                        <!-- BOTÓN GUARDAR -->
                        <v-col v-if="companySelected" cols="12" sm="3" class="d-flex align-center">
                            <v-btn class="ma-2" :loading="loadingConfig" :disabled="loadingConfig"
                                style="background-color:rgb(204 33 40);color:white !important"
                                @click="saveConfiguration">
                                Guardar
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- ALERTAS -->
                    <v-row>
                        <v-col cols="12">
                            <v-alert v-show="successAlert" type="success" text>
                                {{ msgSuccessAlert }}
                            </v-alert>

                            <v-alert v-show="errorAlert" type="warning" text>
                                {{ msgErrorAlert }}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-text>
            </base-card>
        </v-form>
    </v-col>
</template>

<script>
export default {
    name: 'AddTallaColor',

    data() {
        return {
            data: {
                IdCompania: null,
                enabled: false,
            },

            nameParam: 'ADD_TALLA_COLOR',
            codeParam: 2,

            search: '',
            isAdmin: false,
            companySelected: false,
            loadingConfig: false,

            companySelectorError: false,
            helperSelectorText: '',
            firstTimeCompany: true,

            successAlert: false,
            msgSuccessAlert: '',
            errorAlert: false,
            msgErrorAlert: '',
        };
    },

    computed: {
        detailClients() {
            const response = this.$store.state.clients.listClients;
            const companies =
                response && Array.isArray(response.Mensaje)
                    ? response.Mensaje
                    : [];

            let filteredCompanies = companies.filter(
                (company) => Number(company.Activo) === 1
            );

            if (!this.isAdmin) {
                const sessionCompany = this.getSessionCompanyId();

                filteredCompanies = filteredCompanies.filter(
                    (company) =>
                        Number(company.IdCompania) ===
                        Number(sessionCompany)
                );
            }

            return filteredCompanies
                .filter((company) =>
                    (company.NombreCompania || '')
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
                )
                .map((company) => ({
                    ...company,
                    text: `[${company.IdCompania}] ${company.NombreCompania}`,
                }));
        },
    },

    created() {
        this.setUserRole();
        this.getListClients();

        if (!this.isAdmin) {
            this.setSessionCompany();
        }
    },

    methods: {
        // ============================================================
        // USUARIO / SESIÓN
        // ============================================================

        setUserRole() {
            const roleStorage = localStorage.getItem('role');

            if (!roleStorage) {
                this.isAdmin = false;
                return;
            }

            try {
                const roles = JSON.parse(roleStorage);

                this.isAdmin =
                    Array.isArray(roles) &&
                    (
                        roles.includes('Administrador') ||
                        roles.includes('AdminI+D') ||
                        roles.includes('Desarrollador')
                    );
            } catch (error) {
                console.error('Error interpretando role:', error);
                this.isAdmin = false;
            }
        },

        getSessionCompanyId() {
            const uid = localStorage.getItem('uid');

            if (!uid) {
                return null;
            }

            try {
                const sessionData = JSON.parse(atob(uid));

                return sessionData.idcompania || null;
            } catch (error) {
                console.error('Error interpretando uid:', error);
                return null;
            }
        },

        setSessionCompany() {
            const companyId = this.getSessionCompanyId();

            if (!companyId) {
                console.error(
                    'No se encontró la compañía en la sesión.'
                );
                return;
            }

            this.data.IdCompania = Number(companyId);
            this.companySelected = true;

            this.getConfiguration();
        },

        // ============================================================
        // COMPAÑÍAS
        // ============================================================

        async getListClients() {
            try {
                await this.$store.dispatch(
                    'clients/getListClients'
                );
            } catch (error) {
                console.error(
                    'Error consultando compañías:',
                    error
                );
            }
        },

        handleSelectCompany(newValue) {
            this.clearAlerts();

            this.firstTimeCompany = false;
            this.companySelectorError = false;
            this.helperSelectorText = '';

            this.data.enabled = false;
            this.companySelected = !!newValue;

            if (!this.companySelected) {
                return;
            }

            this.getConfiguration();
        },

        validateCompanyField(value) {
            if (
                !value &&
                this.firstTimeCompany === false
            ) {
                this.companySelectorError = true;
                this.helperSelectorText =
                    'El campo compañía no puede estar vacío.';

                return false;
            }

            this.companySelectorError = false;
            this.helperSelectorText = '';

            return true;
        },

        // ============================================================
        // CONVERSIÓN DEL VALOR
        // ============================================================

        normalizeBoolean(value) {
            if (typeof value === 'boolean') {
                return value;
            }

            if (typeof value === 'number') {
                return value === 1;
            }

            if (typeof value === 'string') {
                const normalizedValue = value
                    .trim()
                    .toLowerCase();

                return [
                    '1',
                    'true',
                    'si',
                    'sí',
                    'yes',
                ].includes(normalizedValue);
            }

            return false;
        },

        // ============================================================
        // CONSULTAR CONFIGURACIÓN
        // ============================================================

        async getConfiguration() {
            if (!this.data.IdCompania) {
                return;
            }

            this.loadingConfig = true;

            try {
                const response = await this.$store.dispatch(
                    'companyParams/getConfigParam',
                    {
                        idCompany: this.data.IdCompania,
                        nameParam: this.nameParam,
                    }
                );

                if (
                    response === null ||
                    response === undefined ||
                    response === ''
                ) {
                    this.data.enabled = false;
                } else {
                    this.data.enabled =
                        this.normalizeBoolean(response);
                }
            } catch (error) {
                console.error(
                    'Error consultando configuración:',
                    error
                );

                this.data.enabled = false;

                this.showError(
                    'No fue posible consultar la configuración.'
                );
            } finally {
                this.loadingConfig = false;
            }
        },

        // ============================================================
        // GUARDAR CONFIGURACIÓN
        // ============================================================

        async saveConfiguration() {
            this.clearAlerts();

            if (
                !this.validateCompanyField(
                    this.data.IdCompania
                )
            ) {
                return;
            }

            if (!this.data.IdCompania) {
                this.showError(
                    'Debe seleccionar una compañía.'
                );
                return;
            }

            this.loadingConfig = true;

            try {
                const response = await this.$store.dispatch(
                    'companyParams/updateConfiguration',
                    {
                        idCompany: this.data.IdCompania,

                        // Se envía 1 para activar y 0 para desactivar.
                        value: this.data.enabled ? 1 : 0,

                        nameParam: this.nameParam,
                        codeParam: this.codeParam,
                    }
                );

                this.showSuccess(
                    this.getResponseMessage(response)
                );
            } catch (error) {
                console.error(
                    'Error guardando configuración:',
                    error
                );

                this.showError(
                    this.getErrorMessage(error)
                );
            } finally {
                this.loadingConfig = false;
            }
        },

        // ============================================================
        // RESPUESTAS
        // ============================================================

        getResponseMessage(response) {
            if (!response) {
                return 'Configuración guardada correctamente.';
            }

            const data = response.data || response;

            if (typeof data === 'string') {
                return data;
            }

            return (
                data.Mensaje ||
                data.message ||
                data.mensaje ||
                'Configuración guardada correctamente.'
            );
        },

        getErrorMessage(error) {
            const responseData =
                error &&
                error.response &&
                error.response.data;

            if (responseData) {
                return (
                    responseData.Mensaje ||
                    responseData.message ||
                    responseData.mensaje ||
                    'No fue posible guardar la configuración.'
                );
            }

            return (
                (error && error.message) ||
                'No fue posible guardar la configuración.'
            );
        },

        // ============================================================
        // ALERTAS
        // ============================================================

        showSuccess(message) {
            this.msgSuccessAlert =
                message ||
                'Configuración guardada correctamente.';

            this.successAlert = true;
            this.errorAlert = false;
        },

        showError(message) {
            this.msgErrorAlert =
                message ||
                'No fue posible guardar la configuración.';

            this.errorAlert = true;
            this.successAlert = false;
        },

        clearAlerts() {
            this.successAlert = false;
            this.errorAlert = false;

            this.msgSuccessAlert = '';
            this.msgErrorAlert = '';
        },
    },
};
</script>
```
